import React, { useState } from 'react';
import { Minus, Plus, ShoppingCart } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { addToCart } from '../store/slices/cartSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Data for Combo items
const comboItems = [
  {
    id: 'familyDeStress',
    name: 'FAMILY DE STRESS',
    description: 'Chicken Wings, Mini Sliders, Kebab Stick (Beef), French Fries',
    price: 21500,
    isAvailable: true,
    imageUrl: 'https://via.placeholder.com/400x300?text=Family+De+Stress'
  },
  {
    id: 'dipsAndBites',
    name: 'DIPS AND BITES',
    description: 'Oreo Puff Puff, Chicken Wings, Peppered Beef, Peppered Gizzard, Yam Fries, Plantain',
    price: 24500,
    isAvailable: true,
    imageUrl: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1740835857/12_qdvvoe.jpg'
  },
  {
    id: 'fingerLicks',
    name: 'FINGER LICKS',
    description: 'Chicken Wings, Chicken Tenders, Gizzard, Yam Fries, Peppered Snails, Peppered Plantain',
    price: 27000,
    isAvailable: true,
    imageUrl: 'https://via.placeholder.com/400x300?text=Finger+Licks'
  }
];

const ComboComponent = () => {
  const dispatch = useDispatch();
  const [quantities, setQuantities] = useState({});

  // Update the quantity for a combo item
  const handleQuantityChange = (itemId, delta) => {
    setQuantities(prev => ({
      ...prev,
      [itemId]: Math.max(1, (prev[itemId] || 1) + delta)
    }));
  };

  // Add the combo item to the cart
  const handleAddToCart = (item) => {
    const quantity = quantities[item.id] || 1;
    const cartItem = {
      id: `${item.id}-${Date.now()}`,
      name: item.name,
      price: item.price,
      quantity
    };
    dispatch(addToCart(cartItem));
    toast.success(`${item.name} added to cart!`, {
      position: 'top-right',
      autoClose: 3000
    });
  };

  // Render each combo item card
  const renderComboItem = (item) => {
    const quantity = quantities[item.id] || 1;
    return (
      <div key={item.id} className="bg-black rounded-xl overflow-hidden shadow-lg border border-red-600">
        <div className="relative">
          <img
            src={item.imageUrl}
            alt={item.name}
            className="w-full h-48 object-cover"
          />
          <div className="absolute top-4 right-4">
            <div className="bg-black bg-opacity-50 px-3 py-1 rounded-full">
              <span className="bg-red-500 text-white font-medium text-lg py-1 px-3 rounded-full">
                ₦{item.price.toLocaleString()}
              </span>
            </div>
          </div>
        </div>
        <div className="p-6 space-y-4">
          <h3 className="text-red-500 font-bold text-xl">{item.name}</h3>
          <p className="text-gray-400 text-sm">{item.description}</p>
          <div className="flex items-center justify-between pt-2">
            <div className="flex items-center gap-2 bg-black rounded-lg p-1">
              <button
                onClick={() => handleQuantityChange(item.id, -1)}
                className="p-1 text-gray-300 hover:text-red-500 transition-colors"
                disabled={quantity <= 1}
              >
                <Minus className="w-4 h-4"/>
              </button>
              <span className="w-8 text-center font-medium text-red-500">{quantity}</span>
              <button
                onClick={() => handleQuantityChange(item.id, 1)}
                className="p-1 text-gray-300 hover:text-red-500 transition-colors"
              >
                <Plus className="w-4 h-4"/>
              </button>
            </div>
            <button
              onClick={() => handleAddToCart(item)}
              className="flex items-center gap-2 px-6 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors"
              disabled={!item.isAvailable}
            >
              <ShoppingCart className="w-4 h-4"/>
              <span>{item.isAvailable ? 'Add to Cart' : 'Not Available'}</span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-black text-red-500">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {comboItems.map(item => renderComboItem(item))}
        </div>
      </div>
    </div>
  );
};

export default ComboComponent;
